import SyncIcon from '@mui/icons-material/Sync';
import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import classnames from "classnames";
import React, { useRef } from "react";
import theme from "../../../theme";
import InvestorsMultiAction from "../multi-action/InvestorsMultiAction";

const useStyles = makeStyles((theme) => ({
    row: {
        minWidth: '100%',
        width: 'fit-content',
        height: 'fit-content',
        borderBottom: `1px solid ${theme.colors.neutral['400']}`,
        background: `#fff`,
    },
    header: {
        fontFamily: 'Inter',
        fontSize: '1.1rem',
        fontWeight: 'bold',
        color: theme.colors.neutral['900'],
    },
    checkbox: {
        minWidth: 24,
        maxWidth: 24,
    },
    cell: {
        minWidth: 180,
        maxWidth: 180,
        minHeight: 60,
        maxHeight: 60,
        padding: '0 10px',
    },
    narrowCell: {
        minWidth: 150,
        maxWidth: 150,
    },
    narrowerCell: {
        minWidth: 50,
        maxWidth: 50,
    },
    customCell: {
        minWidth: 240,
        maxWidth: 240,
    },
    customNarrowCell: {
        minWidth: 20,
        maxWidth: 20,
    },
    wideCell: {
        minWidth: 280,
        maxWidth: 280,
    },
    widerCell: {
        minWidth: 380,
        maxWidth: 380,
    },
    fullWidthCell: {
        minWidth: 0,
        maxWidth: 'unset !important',
        width: '100%',
    },
    hiddenCell: {
        display: 'none',
    },
    endCell: {
        minWidth: 4,
        maxWidth: 4,
        padding: 'unset',
    },
    commonButton: {
        height: 36,
        borderRadius: 32,
        textTransform: 'none',
        fontSize: '0.95rem',
        fontWeight: 'bold',
    },
    icon: {
        width: 20,
        height: 20,
    }
}));

export const TableHeaders = ['Name', 'Fit score', 'Companies', 'Investors', 'Workspace Admin', 'Email', '[1]', 'Sector', 'Stage', 'Geography', 'Sectors', '[2]', '[added]', '[invite]', '[menu]'];
export const InvestorTableHeaders = ['Name', 'Email', '[1]', 'Sector', 'Stage', 'Geography', '[2]', '[menu]'];
export const SharedTableHeaders = ['Name', 'Companies', 'Investors', 'Sectors', '[added]', '[menu]'];
export const InvitationTableHeaders = ['Name', 'Companies', 'Investors', 'Sectors', '[invite]'];
export const OverviewTableHeaders = ['Name', 'Companies', 'Investors', '[2]', '[menu]'];

const WorkspacesTableHeader: React.FC<{
    columns: string[],
    multiAction?: boolean,
    findInvestor?: boolean,
    onRefreshScores?: () => void,
}> = ({ columns, multiAction, findInvestor, onRefreshScores }) => {
    const classes = useStyles();
    const multiActionRef = useRef<any>(null);

    const showColumn = (column: string) => !!columns.find(col => col === column);

    return (<>
        <Stack direction="row" className={classes.row} alignItems="flex-start" justifyContent="flex-start" ref={multiActionRef}>
            <Stack className={classes.checkbox} />
            {TableHeaders.map((header, i, self) => showColumn(header) && (
                <Stack direction="column" className={classnames(classes.cell,
                    (i === 0) && (findInvestor ? classes.wideCell : classes.customCell),
                    (i === 2) && classes.customCell,
                    (i === 6) && classes.customNarrowCell,
                    (i === 7) && classes.wideCell,
                    (i === 8) && classes.wideCell,
                    (i === 9) && classes.wideCell,
                    (i === 10) && classes.widerCell,
                    (i === 13) && classes.widerCell,
                    (i === self.length - 4) && classes.fullWidthCell,
                    (i === self.length - 3) && classes.customCell,
                    (i === self.length - 1) && classes.narrowerCell)}
                    alignItems={(i === self.length - 1) ? 'flex-end' : 'flex-start'}
                    justifyContent="center" key={'workspaces-table-header-83-' + i}>
                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start">
                        {(!header.startsWith('[') && !header.endsWith(']')) && (
                            <Typography className={classes.header}>{header}</Typography>
                        )}
                        {(['Fit score'].includes(header)) && (<>
                            <ArrowDropDownIcon sx={{ fill: theme.palette.primary.main, transform: 'scale(1.5, 2.5)'}} />
                        </>)}
                        {!!onRefreshScores && (header === 'Fit score') && (<>
                            <Tooltip placement="top-start" title={
                                <Typography component="span" fontSize="0.95rem" fontWeight={500}>
                                    {`Calculate fit scores for each company based on each workspace's preferences.`}
                                </Typography>}
                                componentsProps={{tooltip:{sx:{
                                    display: 'flex', alignItems: 'center', borderRadius: '12px', transform: 'translate(-90px) !important',
                                    backgroundColor: 'rgba(150, 150, 150, 0.95)', width: '210px', height: '110px',  padding: 2,
                                }}}}>
                                <IconButton onClick={() => onRefreshScores?.()} sx={{ padding: 'unset' }} disableRipple>
                                    <SyncIcon sx={{ fill: theme.palette.primary.main, transform: 'scale(1.05, 1.05)', translate: '-5px 1px' }} />
                                </IconButton>
                            </Tooltip>
                        </>)}
                    </Stack>
                </Stack>
            ))}
            <Stack className={classnames(classes.cell, classes.endCell)} />
        </Stack>
        {multiAction && (<InvestorsMultiAction ref={multiActionRef} />)}
    </>);
}

export default WorkspacesTableHeader;